import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import { Component, forwardRef, Input } from '@angular/core';

import { InputSharedComponent } from '../input/input.component';

export const INPUT_CUSTOM_INPUT_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    // tslint:disable-next-line:no-forward-ref
    useExisting: forwardRef(() => PasswordSharedComponent),
    multi: true
};

@Component({
    selector: 'mlp-ng-password',
    templateUrl: './password.component.html',
    providers: [
        INPUT_CUSTOM_INPUT_ACCESSOR
    ]
})

export class PasswordSharedComponent extends InputSharedComponent implements ControlValueAccessor {
    // tslint:disable-next-line:no-input-rename
    @Input('value') _value = '';
    currentInputType = 'password';

    onChange: any = () => {};
    onTouched: any = () => {};

    get value(): any { return this._value; }
    set value(val) {
        this._value = val;
        this.onChange(val);
        this.onTouched();
    }

    writeValue(value): void {
        this.value = value;
    }

    registerOnChange(fn): void {
        this.onChange = fn;
    }

    registerOnTouched(fn): void {
        this.onTouched = fn;
    }

    togglePassword(): void {
        this.currentInputType = this.currentInputType === 'password' ? 'text' : 'password';
    }
}
